const Siniestros = () => {
      return (
      <>
         <div className="section animated fadeIn">
            
            {/* TÍTULO DE LA SECCIÓN */}
            <div className="row mb-title center mb-4">
               <div className="col s12 m12 l12 x12">
                  <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                     SINIESTROS
                  </h4>
               </div>
            </div>

            {/* TARJETA CONTENEDORA */}
            <div className="row justify-content-center">
               <div className="col s12 m12 l12">
                  <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '30px' }}>
                     
                     {[
                        {
                           titulo: 'Formulario de Denuncia de Accidente de Trabajo o Enfermedad Profesional (PDF)',
                           url: `${process.env.REACT_APP_API_URL}/web/download/FormularioDeDenunciadeSiniestrosARTLatitudSurSA.pdf`
                        },
                        {
                           titulo: 'Formulario de Denuncia de Accidente de Trabajo o Enfermedad Profesional (EXCEL)',
                           url: `${process.env.REACT_APP_API_URL}/web/download/FormularioDeDenunciasARTLatitudSur.xlsx`
                        },
                        {
                           titulo: 'Instructivo para Completar el Formulario de Denuncia',
                           url: `${process.env.REACT_APP_API_URL}/web/download/InstructivoCompletarFormularioDeDenuncia.pdf`
                        }
                     ].map((item, idx, arr) => (
                        <div 
                           key={idx} 
                           className="row valign-wrapper" 
                           style={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              marginBottom: idx === arr.length - 1 ? '0' : '15px', 
                              paddingBottom: idx === arr.length - 1 ? '0' : '15px', 
                              borderBottom: idx === arr.length - 1 ? 'none' : '1px solid #e0e0e0' 
                           }}
                        >
                           <div className="col s8 m9 l10">
                              <h6 className="grey-text text-darken-3" style={{ fontWeight: '600', margin: '0', fontSize: '1rem' }}>
                                 {item.titulo}
                              </h6>
                           </div>
                           <div className="col s4 m3 l2 center-align">
                              <a 
                                 href={item.url} 
                                 target="_blank" 
                                 rel="noopener noreferrer" 
                                 className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                                 style={{ borderRadius: '4px', textTransform: 'none', width: '100%' }}
                              >
                                 Descargar
                                 <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '5px' }}>cloud_download</i>
                              </a>
                           </div>
                        </div>
                     ))}

                  </div>
               </div>
            </div>

         </div>
      </>
      )
}

export default Siniestros